import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { ListItem, ListItemIcon, ListItemText, Divider, Typography } from '@material-ui/core';
import { Header, GoNow } from '../../components';
import { WS_ACTION_TYPES, POI_ACTION_TYPES } from '../../redux-saga/actionTypes';
import theme from '../../theme/theme';
import styles from './styles';

const {
  Icons: { navigation },
} = theme;

class FastRoute extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    const { turnByTurnEvent, saveTurnByTurn } = this.props;
    turnByTurnEvent(saveTurnByTurn);
  }

  render() {
    const { poi, routes, summary, classes } = this.props;

    return (
      <React.Fragment>
        <Header title={poi.name} subtitle={summary} />
        <Divider />
        <div className={classes.scroll__view}>
          {routes.map(list => (
            <React.Fragment>
              <ListItem className={classes.list__container}>
                <ListItemIcon>
                  <img className={classes.icons} src={navigation[list.pointType]} alt="" />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={<Typography className={classes.title}>{list.distance}</Typography>}
                  secondary={<Typography className={classes.subtitle}>{list.name}</Typography>}
                />
                {list.pointType === 'toll' ? (
                  <ListItemIcon>
                    <span className={classes.price}>{list.price}</span>
                  </ListItemIcon>
                ) : null}
              </ListItem>
              <Divider />
            </React.Fragment>
          ))}
        </div>
        <div className={classes.footer}>
          <GoNow />
        </div>
      </React.Fragment>
    );
  }
}

FastRoute.propTypes = {
  classes: PropTypes.object.isRequired,
  poi: PropTypes.object.isRequired,
  routes: PropTypes.array,
  summary: PropTypes.string,
  turnByTurnEvent: PropTypes.func.isRequired,
  saveTurnByTurn: PropTypes.func.isRequired,
};

const mapStateToProps = ({ poi }) => ({
  poi: poi.incoming_stop,
  routes: poi.turnbyturn_routes,
  summary: poi.summary,
});

FastRoute.defaultProps = {
  routes: [],
  summary: '',
};

const mapDispatchToProps = dispatch => ({
  turnByTurnEvent: payload =>
    dispatch({ type: WS_ACTION_TYPES.WS.ON_MESSAGES_TURN_BY_TURN, payload }),
  saveTurnByTurn: payload =>
    dispatch({ type: POI_ACTION_TYPES.TURN_BY_TURN_FROM_WS.SUCCESS, payload }),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(FastRoute),
);
